import React from 'react';

import { Messages } from '../../../../../gen-src/Localize';
import { VirtualConnectionDownstreamDatasourcesQueryVariables, VirtualConnectionDownstreamDatasourcesQuery, DatasourcesDisplayGridRowDataFragment, VirtualConnectionDownstreamDatasourcesFilteredByTableQueryVariables, VirtualConnectionDownstreamDatasourcesFilteredByTableQuery, PublishedDatasourceSortOrder , VirtualConnectionDownstreamDatasourcesFilteredByTableDocument , VirtualConnectionDownstreamDatasourcesDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper,
} from '../../../data-catalog-shared';
import { DatasourcesDisplayGridRowData, getRowDataForDatasource, DatasourcesDisplayGrid } from '../sharedDisplayGrid/DatasourcesDisplayGrid';
import { DatasourcesValidSortFields } from '../sorting/sortProviders/DatasourcesGridSortProvider';

type QueryVariables = VirtualConnectionDownstreamDatasourcesQueryVariables;
type QueryResults = VirtualConnectionDownstreamDatasourcesQuery;
type QueryResultListNode = DatasourcesDisplayGridRowDataFragment;
type GridRowData = DatasourcesDisplayGridRowData;

type QueryVariablesWithFilter = VirtualConnectionDownstreamDatasourcesFilteredByTableQueryVariables;
type QueryResultsWithFilter = VirtualConnectionDownstreamDatasourcesFilteredByTableQuery;
type QueryResultListNodeWithFilter = DatasourcesDisplayGridRowDataFragment;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  const virtualConnection = resultData && resultData.virtualConnections && resultData.virtualConnections[0];
  return virtualConnection ? virtualConnection.downstreamDatasourcesConnection : null;
}

function selectConnectionListResultForFilteredQuery(
  resultData: QueryResultsWithFilter
): ConnectionListResult<QueryResultListNodeWithFilter> | null {
  const virtualConnection = resultData && resultData.virtualConnections && resultData.virtualConnections[0];
  const virtualConnectionTables = virtualConnection && virtualConnection.tablesConnection && virtualConnection.tablesConnection.nodes;
  const table = virtualConnectionTables && virtualConnectionTables[0];
  return table ? table.downstreamDatasourcesConnection : null;
}

export type VirtualConnectionDownstreamDatasourcesQueryGridProps =
  GridSortProps<DatasourcesValidSortFields> & {
    readonly vizportalUrlId: string;
    readonly filteredTableId: string | null;
    readonly rowCount: number | null;
  };

export function VirtualConnectionDownstreamDatasourcesQueryGrid(props: VirtualConnectionDownstreamDatasourcesQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamDatasourcesLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredDatasourcesLineageGridMessage();

  return props.filteredTableId ? (
    // Query with Selected Field as Filter
    <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
      queryGql={VirtualConnectionDownstreamDatasourcesFilteredByTableDocument}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        selectedTableId: props.filteredTableId,
        orderBy: props.orderBy as PublishedDatasourceSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResultForFilteredQuery}
      mapResultNode={getRowDataForDatasource}
    >
      {({ rowStore }) => <DatasourcesDisplayGrid
        rowStore={rowStore}
        emptyGridMessage={emptyFilteredGridMessage}
        rowCount={props.rowCount}
        orderBy={props.orderBy}
        updateSortOrder={props.updateSortOrder}
      />}
    </PaginatedQueryWrapper>
  ) : (
    // Query without Selection
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={VirtualConnectionDownstreamDatasourcesDocument}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        orderBy: props.orderBy as PublishedDatasourceSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForDatasource}
    >
      {({ rowStore }) => <DatasourcesDisplayGrid
        rowStore={rowStore}
        emptyGridMessage={emptyGridMessage}
        rowCount={props.rowCount}
        orderBy={props.orderBy}
        updateSortOrder={props.updateSortOrder}
      />}
    </PaginatedQueryWrapper>
  );
}
